import React from "react";
import Navbar from "@/components/Navbar";

export default function Privacy() {
    return (
        <div className="min-h-screen bg-ink text-slate-900">
            <Navbar />
            <main className="max-w-3xl mx-auto px-6 lg:px-10 py-16">
                <div className="mono-label mb-3">/ LEGAL</div>
                <h1 className="font-display text-4xl md:text-5xl tracking-tighter mb-6" data-testid="privacy-title">
                    Política de Privacidad
                </h1>

                <div className="border border-amber-300 bg-amber-50 text-amber-800 text-sm rounded-sm p-4 mb-10">
                    <strong>Revisado por un abogado — pendiente de datos de la empresa.</strong> El contenido
                    de este documento ya ha sido revisado y aprobado. Antes de publicarlo, falta rellenar los
                    datos reales del responsable del tratamiento en el punto 1 (razón social, domicilio y
                    número de registro — NRT en Andorra o CIF/NIF en España).
                </div>

                <div className="prose prose-slate max-w-none text-sm leading-relaxed space-y-6 text-slate-700">
                    <p className="text-xs text-slate-400">Última actualización: [fecha]</p>

                    <section>
                        <h2 className="font-display text-xl text-slate-900 mb-2">1. Responsable del tratamiento</h2>
                        <p>El responsable del tratamiento de tus datos personales es [razón social pendiente
                        de confirmar], con domicilio en [dirección pendiente] y número de registro [NRT/CIF
                        pendiente]. Puedes contactar con nosotros en{" "}
                        <a href="mailto:info@vivoz.es" className="text-brand hover:underline">info@vivoz.es</a>{" "}
                        para cualquier cuestión relativa a esta política.</p>
                    </section>

                    <section>
                        <h2 className="font-display text-xl text-slate-900 mb-2">2. Qué datos recogemos</h2>
                        <ul className="list-disc pl-5 space-y-1">
                            <li><strong>Cuenta:</strong> nombre, email, contraseña (guardada solo como hash, nunca en texto plano).</li>
                            <li><strong>Uso del servicio:</strong> historial de sesiones de práctica, transcripciones de texto, puntuaciones, logros, fichas.</li>
                            <li><strong>Cámara y micrófono:</strong> durante una sesión de práctica, el vídeo y audio se procesan en tiempo real en tu propio navegador (MediaPipe) para calcular métricas de contacto visual, parpadeo y postura. <strong>No almacenamos vídeo ni grabaciones de tu cámara</strong> — solo las métricas numéricas resultantes. Estas métricas, al derivarse del análisis de tu rostro, se consideran datos susceptibles de mayor protección; tratamos su base jurídica como tu consentimiento explícito, que se solicita mediante un aviso dedicado antes de activar la cámara y que puedes retirar en cualquier momento desactivándola.</li>
                            <li><strong>Voz:</strong> tu voz se transcribe a texto (en el navegador con Chrome, o mediante la API de Whisper de OpenAI en otros navegadores). El audio enviado a Whisper se procesa para generar la transcripción y no lo conservamos nosotros tras ese proceso; consulta la política de OpenAI para su propia retención.</li>
                            <li><strong>Pagos:</strong> gestionados directamente por Stripe. No almacenamos números de tarjeta en nuestros servidores.</li>
                        </ul>
                    </section>

                    <section>
                        <h2 className="font-display text-xl text-slate-900 mb-2">3. Base jurídica del tratamiento</h2>
                        <p>Tratamos tus datos de cuenta y de uso del servicio porque son necesarios para
                        ejecutar el contrato de prestación del Servicio (art. 6.1.b RGPD). Los datos de cámara
                        y micrófono se tratan con base en tu consentimiento explícito (art. 6.1.a y 9.2.a
                        RGPD), que puedes retirar en cualquier momento sin afectar al resto del Servicio. Los
                        datos de facturación se tratan para cumplir obligaciones legales (art. 6.1.c RGPD).</p>
                    </section>

                    <section>
                        <h2 className="font-display text-xl text-slate-900 mb-2">4. Para qué usamos tus datos</h2>
                        <p>Para operar el Servicio (crear tu cuenta, ejecutar sesiones de práctica, calcular
                        puntuaciones y logros, procesar pagos), mejorar el producto, y comunicarnos contigo
                        sobre tu cuenta (por ejemplo, restablecimiento de contraseña).</p>
                    </section>

                    <section>
                        <h2 className="font-display text-xl text-slate-900 mb-2">5. Con quién compartimos datos</h2>
                        <ul className="list-disc pl-5 space-y-1">
                            <li><strong>OpenAI</strong> (Estados Unidos) — procesa el texto de tus conversaciones de práctica y, si aplica, el audio para transcripción. Al tratarse de una transferencia internacional de datos fuera del Espacio Económico Europeo y de Andorra, se ampara en las Cláusulas Contractuales Tipo de la Comisión Europea suscritas por OpenAI.</li>
                            <li><strong>Stripe</strong> — procesa tus pagos y datos de facturación, también bajo Cláusulas Contractuales Tipo cuando aplica transferencia internacional.</li>
                            <li><strong>Propietario de tu equipo</strong> (solo si te unes a una cuenta Studio como invitado) — ve tu puntuación media y número de sesiones agregados.</li>
                            <li>Otros usuarios — si participas en la clasificación pública, tu nombre y puntuación son visibles para ellos.</li>
                        </ul>
                        <p className="mt-2">No vendemos tus datos a terceros con fines publicitarios.</p>
                    </section>

                    <section>
                        <h2 className="font-display text-xl text-slate-900 mb-2">6. Dónde se almacenan los datos</h2>
                        <p>Los datos de tu cuenta y sesiones se almacenan en MongoDB Atlas. La región de
                        almacenamiento depende de la configuración del despliegue — indícala aquí una vez
                        decidida (recomendado: una región de la UE, para simplificar el cumplimiento tanto
                        con el RGPD como con la ley andorrana, que exige garantías equivalentes para
                        transferencias fuera de Andorra).</p>
                    </section>

                    <section>
                        <h2 className="font-display text-xl text-slate-900 mb-2">7. Cuánto tiempo conservamos tus datos</h2>
                        <p>Mientras tu cuenta esté activa. Si eliminas tu cuenta, borraremos o anonimizaremos
                        tus datos personales en un plazo razonable, salvo obligación legal de conservarlos
                        (por ejemplo, registros de facturación, que la normativa mercantil española y
                        andorrana exige conservar varios años).</p>
                    </section>

                    <section>
                        <h2 className="font-display text-xl text-slate-900 mb-2">8. Tus derechos</h2>
                        <p>Tienes derecho a acceder, rectificar, suprimir, limitar y oponerte al tratamiento
                        de tus datos personales, así como a la portabilidad de estos, en los términos
                        previstos por el RGPD y la LOPDGDD (si resides en España) o por la Llei 29/2021 (si
                        resides en Andorra). Para ejercerlos, escribe a{" "}
                        <a href="mailto:info@vivoz.es" className="text-brand hover:underline">info@vivoz.es</a>.
                        Si no quedas satisfecho con nuestra respuesta, puedes reclamar ante la Agencia Española
                        de Protección de Datos (AEPD, aepd.es) o ante la Agència Andorrana de Protecció de
                        Dades (APDA, apda.ad), según tu país de residencia.</p>
                    </section>

                    <section>
                        <h2 className="font-display text-xl text-slate-900 mb-2">9. Cookies</h2>
                        <p>Usamos almacenamiento local del navegador (localStorage) para mantener tu sesión
                        iniciada. No usamos cookies de seguimiento publicitario ni de análisis de terceros.</p>
                    </section>

                    <section>
                        <h2 className="font-display text-xl text-slate-900 mb-2">10. Menores de edad</h2>
                        <p>El Servicio no está dirigido a menores de 16 años y no recogemos
                        conscientemente datos de menores de esa edad.</p>
                    </section>

                    <section>
                        <h2 className="font-display text-xl text-slate-900 mb-2">11. Cambios en esta política</h2>
                        <p>Podemos actualizar esta política ocasionalmente. Te avisaremos de cambios
                        materiales por email o mediante un aviso en la aplicación, y te pediremos que la
                        aceptes de nuevo la próxima vez que inicies sesión.</p>
                    </section>

                    <section>
                        <h2 className="font-display text-xl text-slate-900 mb-2">12. Contacto</h2>
                        <p>Para cualquier duda sobre privacidad, escribe a{" "}
                        <a href="mailto:info@vivoz.es" className="text-brand hover:underline">info@vivoz.es</a>.</p>
                    </section>
                </div>
            </main>
        </div>
    );
}
